import { SxProps, Theme } from '@mui/material';

// Size variants
const sizes = {
  medium: { width: 72, height: 72 },
  xlarge: { width: 148, height: 148 },
  large: { width: 200, height: 200 },
};

export const container = (
  size: 'medium' | 'xlarge' | 'large',
): SxProps<Theme> => ({
  position: 'relative',
  ...sizes[size],
  cursor: 'pointer',
});

export const playButtonOverlay: SxProps<Theme> = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'rgba(0, 0, 0, 0.3)',
  opacity: 0,
  transition: 'opacity 0.2s ease-in-out',
  cursor: 'pointer',
};

export const playIcon: SxProps<Theme> = {
  fontSize: '2rem',
  color: 'white',
};
